import { render } from "./AccountModal.vue?vue&type=template&id=127feaee&scoped=true"
import script from "./AccountModal.vue?vue&type=script&lang=js"
export * from "./AccountModal.vue?vue&type=script&lang=js"

import "./AccountModal.vue?vue&type=style&index=0&id=127feaee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127feaee"]])

export default __exports__